import {useQuery} from '@tanstack/react-query';
import { authorizedGet } from '../functions/AuthService';

export const usePurchaseNeeds = () => {
    return useQuery({
        queryKey: ['inventory', 'needs'],
        queryFn: async () => {
            const response = await authorizedGet("/mrp/getNeeds");
            const resData = await response.body.json();
            // console.log("Data: ", resData);
            return resData;
        },
        staleTime: 1000 * 60 * 5, //5 minutes
        gcTime: 1000 * 60 * 30, //Keep it in memory for 30 minutes
        refetchOnWindowFocus: false //Prevent refresh if the tab is clicked
    });
}